import React from "react";
import { css } from "emotion";
import Button from "../../../components/global/Button";
import { H3, P } from "../../../components/global";
import { max } from "../../../utils/CssUtils";

const wrapper = css({
  padding: "40px 0",
  margin: "72px auto 0 auto",
  textAlign: "center",
  background: "white",
  maxWidth: 1040,
  [max(768)]: {
    marginTop: 40,
    padding: "24px 0"
  }
});

const textWrapper = css({
  maxWidth: 460,
  padding: "0 32px",
  margin: "16px auto"
});

const buttonWrapper = css({
  maxWidth: 272,
  margin: "24px auto 0"
});

const defaults = {
  heading: "Thinking big?",
  text:
    "We can help with custom development, staffing, marketing support and more.",
  link: "contact-us/organiser-support",
  buttonText: "Get in touch"
};

const GetInTouch = props => {
  const settings = { ...props, ...defaults };

  return (
    <div className={wrapper}>
      <H3>{settings.heading}</H3>
      <div class={textWrapper}>
        <P>{settings.text}</P>
      </div>
      <div class={buttonWrapper}>
        <Button
          size="wide"
          style="hollow"
          color="secondary"
          link={`/${settings.locale}/${settings.link}`}
          ariaLabel={settings.buttonText}
        >
          {settings.buttonText}
        </Button>
      </div>
    </div>
  );
};

export default GetInTouch;
